










































































































import Vue from "vue";
export default Vue.extend({
  name: "registrado",
  props: ["dialog", "datos", "evaluadorRegistrado"],
});
